import styled, { css } from 'styled-components';

import { Text, Dropdown, Button, List, Box } from '@gympass/yoga';
import { IconButton, Typography } from '@mui/material';
import { wellzTheme } from '@wellz-theme/mui';

import { Button as WellzButton } from 'components';
import { Divisor } from 'pages/EndUser/styles';

export const CardTitle = styled(Text.H5)`
  margin-bottom: ${({ theme }) => theme.yoga.spacing.medium}px;
`;

export const CardSubTitle = styled(Text.Small)`
  color: ${({ theme }) => theme.yoga.colors.deep};
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
`;

export const FormHeading = styled(Text.Medium)`
  margin-bottom: ${({ theme }) => theme.yoga.spacing.small}px;
`;

export const TimeHeading = styled(Text.Regular)`
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
`;

export const Form = styled(Box)`
  display: flex;
  flex-direction: column;
`;

const dropDownStyles = css`
  *,
  *::after,
  *::before {
    color: ${({ theme }) => theme.yoga.colors.deep} !important;
  }

  > div {
    border-color: ${({ theme }) => theme.yoga.colors.tableBorder};
  }

  svg {
    fill: ${({ theme }) => theme.yoga.colors.deep};
  }
`;

export const TypeDropdown = styled(Dropdown)`
  ${dropDownStyles};
  margin-bottom: ${({ theme }) => theme.yoga.spacing.large}px;
  width: 100%;
`;

export const AddButton = styled(props => <WellzButton {...props} />)`
  height: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  max-width: ${({ theme }) => theme.yoga.sizes.occasionalAddButtonWidth}px;

  margin-top: ${wellzTheme.spacing(2)};

  @media screen and (max-width: 1024px) {
    max-width: 100%;
  }
`;

export const PurpleColor = styled(Text)`
  color: ${({ theme }) => theme.yoga.colors.primaryLight};
`;

export const ListItem = styled(List.Item)`
  padding: ${({ theme }) => theme.yoga.spacing.zero};
  align-items: center;
  display: flex;
`;

export const ListItemText = styled(Typography)`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
`;

export const StyledBox = styled(Box).attrs({
  display: 'flex',
  alignItems: 'center',
})`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${wellzTheme.spacing(2)};

  padding-bottom: ${wellzTheme.spacing(1.25)};
  padding-left: ${wellzTheme.spacing(2)};
  border-bottom: 1px solid ${wellzTheme.palette.divider};

  & + ${Box} {
    margin-top: ${wellzTheme.spacing(2)};
  }
`;

export const StyledTrashButton = styled(Button.Icon)`
  width: ${({ theme }) => theme.yoga.spacing.large}px;
  height: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const PrepositionText = styled(Text)`
  color: ${({ theme }) => theme.yoga.colors.deep};
`;

export const StyledDivisor = styled(Divisor)`
  margin: ${({ theme }) => theme.yoga.spacing.small}px
    ${({ theme }) => theme.yoga.spacing.zero};
  border-color: ${({ theme }) => theme.yoga.colors.primary};
`;

export const ListAccordionButton = styled(Button.Text)`
  color: ${({ theme }) => theme.yoga.colors.primary};
  margin: ${({ theme }) => theme.yoga.spacing.zero} auto;
  height: ${({ theme }) => theme.yoga.spacing.small}px;
  flex-direction: row-reverse;

  svg {
    margin-left: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  }
`;

export const AvailabilityEmptyState = styled(CardSubTitle)`
  margin-top: ${({ theme }) => theme.yoga.spacing.small}px;
`;

export const ContentContainer = styled.div`
  display: flex;
  width: 100%;

  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const AvailabilitySections = styled.section`
  width: 50%;

  & + & {
    margin-left: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  }

  &:first-of-type {
    padding-right: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  }

  @media (max-width: 800px) {
    width: 100%;

    & + & {
      margin-left: ${({ theme }) => theme.yoga.spacing.zero}px;
      margin-top: ${({ theme }) => theme.yoga.spacing.large}px;
    }

    &:first-of-type {
      padding-right: ${({ theme }) => theme.yoga.spacing.zero}px;
    }
  }
`;

export const DeleteAvailabilityButton = styled(IconButton)`
  margin-left: auto;
  height: ${wellzTheme.spacing(2.5)};
  width: ${wellzTheme.spacing(2.5)};

  svg {
    fill: ${wellzTheme.palette.text.secondary};
  }
`;
